export const SSO_REQUEST = 'SSO_REQUEST';
export const SSO_FAILURE = 'SSO_FAILURE';
